// Single source of truth for settlement status colors/labels/icons, matching the Canva design.
// Ikony (kolor wbudowany per status) używane m.in. na wizytówkach opiekunów.
export const SETTLEMENT_STATUS_META = {
  NIEROZLICZONO: {
    label: "NIEROZLICZONO",
    color: "#e02424",
    icon: require("../../../icons/dod/settlement/nierozliczono.svg"),
  },
  W_TRAKCIE: {
    label: "W TRAKCIE",
    color: "#d6006d",
    icon: require("../../../icons/dod/settlement/w-trakcie.svg"),
  },
  DO_WERYFIKACJI: {
    label: "DO WERYFIKACJI",
    color: "#1f9d55",
    icon: require("../../../icons/dod/settlement/do-weryfikacji.svg"),
  },
  DO_POPRAWY: {
    label: "DO POPRAWY",
    color: "#f39c12",
    icon: require("../../../icons/dod/settlement/do-poprawy.svg"),
  },
  ROZLICZONO: {
    label: "ROZLICZONO",
    color: "#8a8a8a",
    icon: require("../../../icons/dod/settlement/rozliczono.svg"),
  },
};

export function statusMeta(status) {
  return SETTLEMENT_STATUS_META[status] || SETTLEMENT_STATUS_META.NIEROZLICZONO;
}
